import React, {Fragment} from "react";
import {withRouter} from "react-router";
import UserSessionService from "../../services/UserSessionService";
import ChatConversationService from "../../services/chat/ChatConversationService";
import ToastHelper from "../../utils/ToastHelper";
import SFXLoadingComponent from "../../components/SFXLoadingComponent";
import ViewHeaderComponent from "../../components/ViewHeaderComponent";
import ConversationCard from "../../components/chat/ConversationCard";
import {Button} from "reactstrap";
import QueryStringUtils from "../../utils/QueryStringUtils";
import "scss/Chat.css";

class ChatsHistory extends React.Component {
    constructor(props) {
        super(props);


        let resourceType = QueryStringUtils.getQueryStringValue('rt');
        let resourceId = QueryStringUtils.getQueryStringValue('ri');
        let hasContext = !!resourceType && !!resourceId;
        this.state = {
            isLoading: true,
            gotConversations: false,
            resourceType: resourceType,
            resourceId: resourceId,
            hasContext: hasContext
        }
        this.props.changeHeader("Chat");
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        let newState = {
            isLoading: false
        };
        newState.apiUser = UserSessionService.getUser().user;

        let initialPromises = [];
        let conversationsIndex = initialPromises.length;
        if (this.state.hasContext) {
            initialPromises[conversationsIndex] = ChatConversationService.retrieveClosedForUserAndContext(newState.apiUser.id, this.state.resourceType, this.state.resourceId)
        } else {
            initialPromises[conversationsIndex] = ChatConversationService.retrieveClosedForUser(newState.apiUser.id);
        }

        Promise.all(initialPromises).then(
            initialResponses => {
                if (!Array.isArray(initialResponses[conversationsIndex])) {
                    ToastHelper.formatError(initialResponses[conversationsIndex])
                    return;
                }
                newState.gotConversations = initialResponses[conversationsIndex].length > 0;
                newState.conversations = initialResponses[conversationsIndex];
                this.setState(newState)
            }
        )


    }

    onBackClick() {
        this.props.history.goBack();
    }

    render() {
        if (this.state.isLoading) {
            return <SFXLoadingComponent/>
        }

        return <div className={"chatContainer"}>
        <Fragment>
            <ViewHeaderComponent>
                <div className={"chatHistoryHeaderSection"}>
                    <Button
                        onClick={this.onBackClick.bind(this)}
                        className={"fa fa-arrow-left chatLeftArrow"}
                    />
                    <div className={"chatHistoryText"}>
                        Chat History
                    </div>
                </div>
            </ViewHeaderComponent>
            {
                this.state.gotConversations &&
                <Fragment>
                    {
                        this.state.conversations.map(conversation => {
                            return this.renderConversation(conversation, false);
                        })
                    }
                </Fragment>
            }
            {
                !this.state.gotConversations &&
                <div style={{textAlign: "center", fontWeight: "bold"}}>
                    You have no closed conversations at this time.
                </div>
            }
        </Fragment>
        </div>
    }

    renderConversation(conversation) {
        return <ConversationCard key={conversation.id}
                                 {...this.props}
                                 conversation={conversation}
        />
    }

}

export default withRouter(ChatsHistory)